<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索客户..."
          @on-change="searchSalesPromoFee"
          clearable
          icon="ios-search"
          style="width: 250px; margin-right: 20px"
        >
        </Input>
        <Select
          @on-change="selectStatusMethod"
          v-model="selectStatus"
          style="width: 100px"
        >
          <Option
            v-for="item in statusList"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
      </Select>
      </div>
      <div class="handle-right">
        <span>共{{ totalRows }}条</span>
        <Page
          :total="totalRows"
          :page-size="20"
          @on-change="loadSalesPromoFee"
          show-total
          simple
          style="margin-right: 24px"
        />
        <Button
          type="primary"
          @click="openCreateSalesPromoFeeDrawer()"
          >新增业务费</Button
        >
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table :columns="columns" :data="salesPromoFeeRecordList" :height="tableHeight"> </Table>
    </div>
    <EditSalesPromoFeeDrawer ref="EditSalesPromoFeeDrawer" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
import _ from "lodash";
import EditSalesPromoFeeDrawer from './EditSalesPromoFeeDrawer.vue'

export default {
  name:'SalesPromoFeePage',
  components: { EditSalesPromoFeeDrawer },
  data() {
    return {
      page: 0,
      limit: 20,
      searchText: "",
      tableLoading: false,
      selectStatus: 'active',
      statusList: [
        {
          value: "all",
          label: "全部",
        },
        {
          value: "active",
          label: "可用",
        },
        {
          value: "unActive",
          label: "禁用",
        },
      ],
      filterQuery: {},
      columns: [
        
        {
          title: "行",
          key: "row",
          width: 60,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 20 + params.index + 1
            ),
        },
        {
          title: "禁用",
          key: "active",
          align: "center",
          width: 45,
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  color: "#ed4014"
                }
              },
              params.row.active ? "" : "是"
            );
          }
        },
        {
          title: "联系人",
          minWidth: 70,
          maxWidth: 120,
          key: "customerContact",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  style: {
                    cursor: "pointer",
                    color: "#42b983",
                  },
                  on: {
                    click: () => {
                      this.$refs.EditSalesPromoFeeDrawer.openDrawer(params.row);
                    },
                  },
                },
                params.row.customerContact.name
              ),
            ]);
          },
        },
        {
          title: "销售项目",
          key: "sales",
          minWidth: 110,
          align: "center",
          render: (h, params) =>
            h("span", params.row.sales && params.row.sales.abbr  ? params.row.sales.abbr : "")
        },
        {
          title: "费用",
          minWidth: 70,
          maxWidth: 120,
          key: "fee",
          align: "left",
        },
        {
          title: "生效日期",
          key: "startActiveDate",
          minWidth: 110,
          align: "center",
          render: (h, params) =>
            h("span", params.row.startActiveDate ? dayjs(params.row?.startActiveDate).format("YYYY-MM-DD") : null),
        },
        {
          title: "失效日期",
          key: "endActiveDate",
          minWidth: 110,
          align: "center",
          render: (h, params) =>
            h("span", params.row.endActiveDate ? dayjs(params.row?.endActiveDate).format("YYYY-MM-DD") : null),
        },
        {
          title: "创建人",
          key: "createdBy",
          minWidth: 110,
          align: "center",
          render: (h, params) =>
            h("span", params.row?.createdBy?.name),
        },
        {
          title: "备注",
          minWidth: 70,
          key: "remark",
          align: "left",
        },
      ],
      tableHeight: 300,
    }
  },
  computed: mapState({
    totalRows: (state) => state.salesPromoFeeRecord.totalCounts,
    salesPromoFeeRecordList: (state) => state.salesPromoFeeRecord.salesPromoFeeRecordList,
  }),
  methods:{
    ...mapActions({
      getUsers: "user/getUsersAction",
      getSalesPromoFee: "salesPromoFeeRecord/getSalesPromoFeeAction",
    }),
    async loadSalesPromoFee(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      switch (this.selectStatus) {
        case 'unActive':
          this.filterQuery.active = false
          break;
        case 'active':
          this.filterQuery.active = true
          break;
        case 'all':
          delete this.filterQuery.active
          break;
      }
      try {
        this.tableLoading = true;
        await this.getSalesPromoFee(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.tableLoading = false;
      }
    },
    searchSalesPromoFee: _.debounce(function () {
      this.page = 0;
      this.loadSalesPromoFee();
    }, 1000),
    selectStatusMethod(status) {
      this.loadSalesPromoFee();
    },
    openCreateSalesPromoFeeDrawer() {
      this.$refs.EditSalesPromoFeeDrawer.openDrawer()
    },
  },
  async created() {
    this.loadSalesPromoFee();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
}
</script>

<style lang="stylus" scoped>
.container
  overflow-y auto

.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>